import type { IndexUiState } from 'instantsearch.js';

export const getRefinementSignature = (state: IndexUiState = {}) => {
  const refinements: IndexUiState = { ...state };
  delete refinements.page;

  return JSON.stringify(refinements, (_key, value) =>
    value && typeof value === 'object' && !Array.isArray(value)
      ? Object.fromEntries(
          Object.entries(value).sort(([a], [b]) => a.localeCompare(b))
        )
      : value
  );
};

export const classifyUiStateChange = (
  state: IndexUiState | undefined,
  lastSignature: string | null
) => {
  const signature = getRefinementSignature(state);

  return {
    signature,
    isPaginationOnly: (state?.page ?? 0) > 0 || lastSignature === signature,
  };
};
